export default "__VITE_ASSET__QLtN$$e___"